import {
  apiCallWithAuth,
  apiCallWithAuthWithReturn,
  handleResponseErrorData,
} from "../../clinic/utils/commonUtils";

const API_URL = process.env.REACT_APP_API_URL;

export const fetchDoctorsWithClinicId = async (clinicId) => {
  const url = `${process.env.REACT_APP_API_URL}/auth/fetchDoctorsWithClinicId?clinic_id=${clinicId}`;
  const data = null;
  return await apiCallWithAuthWithReturn(url, "GET", data, {}, null);
};

export const fetchPatients = async (doctorId) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/patients?doctorId=${doctorId}`;
    const data = null;
    return await apiCallWithAuth(url, "GET", data, {}, null);
  } catch (error) {
    throw new Error("Error fetching patients: " + error.message);
  }
};

export const fetchDoctors = async (clinicId) => {
  const url = `${process.env.REACT_APP_API_URL}/auth/fetchDoctorsWithClinicId?clinic_id=${clinicId}`;
  const data = null;
  return await apiCallWithAuthWithReturn(url, "GET", data, {}, null);
};

export const fetchPatientsAndRelatives = async (userId, otpVerified) => {
  try {
    const data1 = JSON.stringify({ userId });
    const url = `${API_URL}/auth/getPatientAndRelatives`;
    const response = await apiCallWithAuthWithReturn(
      url,
      "POST",
      data1,
      { token_type: "pat" },
      null
    );
    const data = await response.data;
    if (
      data.patientInfo.patient ||
      data.relatedPatientsInfo.relatedPatients.length > 0
    ) {
      const list = [
        data.patientInfo.patient,
        ...data.relatedPatientsInfo.relatedPatients,
      ].filter(Boolean);
      return list;
    } else {
      return [];
    }
  } catch (error) {
    throw new Error("Error fetching patients: " + error.message);
  }
};

export const createAppointmentForMember = async (
  patientId,
  doctorId,
  clinicId
) => {
  try {
    const url = `${process.env.REACT_APP_API_URL}/appointments/createAppointment`;
    const data = JSON.stringify({ patientId, doctorId, clinicId });
    return await apiCallWithAuth(url, "POST", data, {}, null);
  } catch (error) {
    throw new Error("Error creating appointment: " + error.message);
  }
};
